
import React, { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ADMIN_API } from '../../../common/common';
import { Logout } from '../../../common/Funcation';
import { styleObjectBlackButton } from '../../../common/StyleSeter';
import SkyPopup from '../../../components/SkyPopup'
import { notifyError, notifyMessage, postApi } from '../../../service';
import { useResultPanelSocketRefresh } from '../../../hooks/useResultPanelSocketRefresh';
import { manageBetList, managehistoryPre, managePremiumInterface } from '../interface';

type SettleMode = 'single' | 'deadHeat' | 'cancel' | 'allNamed'

function formatDeclaredWinners(winner: unknown): string {
  if (Array.isArray(winner)) {
    return winner.filter(Boolean).map(String).join(', ')
  }
  const raw = String(winner || '').trim()
  if (!raw) return ''
  return raw.split('#').map((part) => part.trim()).filter(Boolean).join(', ')
}

function flattenRunners(winnerSelection: unknown): string[] {
  const out: string[] = []
  const seen = new Set<string>()
  const walk = (value: unknown) => {
    if (value == null) return
    if (Array.isArray(value)) {
      value.forEach(walk)
      return
    }
    const name = String(value).trim()
    if (!name || name === 'cancel' || seen.has(name)) return
    seen.add(name)
    out.push(name)
  }
  walk(winnerSelection)
  return out
}

function settlementPreview(
  mode: SettleMode,
  winners: string[],
  runners: string[]
): { name: string; result: string; tone: 'win' | 'lose' | 'void' | 'split' }[] {
  if (mode === 'cancel') {
    return runners.map((r) => ({ name: r, result: 'VOID — stake returned', tone: 'void' as const }))
  }
  const picked = new Set(winners.filter((w) => w && w !== 'cancel'))
  const n = Math.max(1, picked.size)
  return runners.map((r) => {
    if (!picked.has(r)) return { name: r, result: 'LOSE', tone: 'lose' as const }
    if (mode === 'deadHeat' && n > 1) {
      return { name: r, result: `TIE — win ~1/${n} of normal profit`, tone: 'split' as const }
    }
    if (mode === 'allNamed') {
      return { name: r, result: 'WIN (full profit)', tone: 'win' as const }
    }
    return { name: r, result: 'WIN (full profit)', tone: 'win' as const }
  })
}

function modeHelp(mode: SettleMode): string {
  switch (mode) {
    case 'single':
      return 'Normal case: pick the one outcome that won. Everyone else loses.'
    case 'deadHeat':
      return 'Only if the result is a tie. Tick every tied outcome. Profit is shared (not full win each).'
    case 'cancel':
      return 'Use when the market is void (no result). All players get stake back.'
    case 'allNamed':
      return 'Rare. Every ticked outcome is paid as a full winner. Wrong use causes overpay — avoid unless you are sure.'
    default:
      return ''
  }
}

function submitButtonLabel(mode: SettleMode): string {
  switch (mode) {
    case 'cancel':
      return 'Void market'
    case 'deadHeat':
      return 'Publish tie result'
    case 'allNamed':
      return 'Publish (advanced)'
    default:
      return 'Publish winner'
  }
}

const MangePremium = () => {
  const { id, type } = useParams()
  const [OpenModal, setOpenModal] = useState<boolean>(false);
  const DD = useSelector((e: any) => e.domainDetails);
  const [isHover, setIsHover] = useState(false);
  const [hoverId, setHoverId] = useState({ isHover: '' })
  const [declaredWinner, setDeclaredWinner] = useState<string[]>([])
  const [settleMode, setSettleMode] = useState<SettleMode>('single')
  const [formError, setFormError] = useState('')
  const [clickedWinner, setClickedWinner] = useState<manageBetList>()
  const handleMouseEnter = (id: string = '') => {
    if (id) { setHoverId({ isHover: id }) }
    setIsHover(true);
  };
  const handleMouseLeave = (id: string = '') => {
    if (id) { setHoverId({ isHover: '' }) }
    setIsHover(false);
  };
  const showAlert = async (item: managehistoryPre) => {
    const market = item?.selection
    const line = item?.lineLabel ? ` (${item.lineLabel})` : ""
    if (!market) {
      notifyError('Missing market name. Rollback was not sent.')
      return
    }
    const winners = formatDeclaredWinners(item?.winner)
    const confirmed = window.confirm(
      `Rollback "${market}${line}" only?\n\nDeclared winners on this line: ${winners || '(none)'}\n\nOther premium lines on this match will stay declared.`
    )
    if (confirmed) {
      const reason = window.prompt("Rollback reason (optional):", "") || "rollBack"
      let data: any = {
        api: ADMIN_API.SETTING.PREMIUM_HISTORY.ROLL_BACK_WINNER,
        value: {
          id: id,
          selection: market,
          lineKey: item?.lineKey || '',
          reason,
        },
      }
      await postApi(data).then(function (response) {
        notifyMessage(response.data.message || "Rollback successful.")
        getPageData()
      }).catch(err => {
        notifyError(err.response?.data?.message || "Rollback failed.")
        if (err.response?.data?.statusCode === 401) {
          Logout()
          navigate('/login')
        }
      })
    }
  }
  const [pageData, setPageData] = useState<managePremiumInterface>()
  const navigate = useNavigate()
  useEffect(() => {
    getPageData()
    return () => {
    }
  }, [])

  const getPageData = async () => {
    let data: any = {
      api: type === 'manage' ? ADMIN_API.SETTING.MANAGE_PREMIUM.LIST_OF_BET : ADMIN_API.SETTING.PREMIUM_HISTORY.LIST_OF_BET,
      value: {
        id: id
      },
    }


    await postApi(data).then(function (response) {
      console.log(response);
      setPageData(response.data.data)

    }).catch(err => {
      // debugger
      if (err.response?.data?.statusCode === 401) {
        Logout()
        navigate('/login')
      }
    })

  }
  useResultPanelSocketRefresh({
    sportType: pageData?.sportInfo?.type || '',
    betTypes: ['premium'],
    enabled: Boolean(id),
    onRefresh: async () => {
      await getPageData()
    },
  })

  const resetDeclareForm = () => {
    setDeclaredWinner([])
    setSettleMode('single')
    setFormError('')
  }
  const declareResultClick = (item: manageBetList) => {
    resetDeclareForm()
    setOpenModal(true)
    setClickedWinner(item)
  }
  const onSettleModeChange = (mode: SettleMode) => {
    setFormError('')
    setSettleMode(mode)
    if (mode === 'cancel') {
      setDeclaredWinner(['cancel'])
      return
    }
    setDeclaredWinner((prev) => prev.filter((n) => n && n !== 'cancel'))
  }
  const onOutcomeToggle = (name: string) => {
    if (settleMode === 'cancel') return
    setFormError('')
    if (settleMode === 'single') {
      setDeclaredWinner([name])
      return
    }
    // deadHeat / allNamed — multi select
    setDeclaredWinner((prev) => {
      const withoutCancel = prev.filter((p) => p !== 'cancel')
      if (withoutCancel.includes(name)) {
        return withoutCancel.filter((p) => p !== name)
      }
      return [...withoutCancel, name]
    })
  }
  const submitWinnerPopup = async (e: any) => {
    e.preventDefault()
    setFormError('')
    if (!clickedWinner?.name) {
      setFormError('Missing market name. Result was not sent.')
      return
    }

    let winnerPayload: string[] = []
    let deadHeat = false
    let mode: SettleMode = settleMode

    if (settleMode === 'cancel') {
      winnerPayload = ['cancel']
      mode = 'cancel'
    } else {
      winnerPayload = declaredWinner.filter((n) => n && n !== 'cancel')
      if (settleMode === 'single') {
        if (winnerPayload.length !== 1) {
          setFormError('Select exactly one winner.')
          return
        }
        mode = 'single'
      } else if (settleMode === 'deadHeat') {
        if (winnerPayload.length < 2) {
          setFormError('Tie / dead heat needs at least two winners.')
          return
        }
        deadHeat = true
        mode = 'deadHeat'
      } else if (settleMode === 'allNamed') {
        if (winnerPayload.length < 2) {
          setFormError('Advanced mode needs at least two named winners.')
          return
        }
        deadHeat = false
        mode = 'allNamed'
      }
    }

    const runners = flattenRunners(clickedWinner?.winnerSelection)
    const preview = settlementPreview(mode, winnerPayload, runners)
    const summary = preview.map((p) => `• ${p.name}: ${p.result}`).join('\n')
    const modeLabel =
      mode === 'single'
        ? 'One winner'
        : mode === 'deadHeat'
          ? 'Tie (dead heat)'
          : mode === 'cancel'
            ? 'Void / cancel'
            : 'Advanced (full pay each)'
    const confirmed = window.confirm(
      `Publish result for market:\n"${clickedWinner.name}"${clickedWinner.lineLabel ? `\nLine: ${clickedWinner.lineLabel}` : ''}\n\nType: ${modeLabel}\n\n${summary || '(void all)'}\n\nOK to publish?`
    )
    if (!confirmed) return

    let data: any = {
      api: ADMIN_API.SETTING.MANAGE_PREMIUM.DECLARE_WINNER,
      value: {
        id: id,
        selection: clickedWinner?.name,
        lineKey: clickedWinner?.lineKey || '',
        winner: winnerPayload,
        deadHeat,
        settleMode: mode,
        reason:
          mode === 'deadHeat'
            ? 'declareWinner deadHeat'
            : mode === 'allNamed'
              ? 'declareWinner allNamed'
              : mode === 'cancel'
                ? 'declareWinner cancel'
                : 'declareWinner',
      },
    }


    await postApi(data).then(function (response) {
      notifyMessage(response.data.message || "Result declared.")
      setOpenModal(false)
      resetDeclareForm()
      getPageData()


    }).catch(err => {
      notifyError(err.response?.data?.message || "Declare failed.")
      if (err.response?.data?.statusCode === 401) {
        Logout()
        navigate('/login')
      }
    })
  }
  return (
    <>
      <div className="container banking website edit main_wrap" >
        <div className='top_header premium-declare-head'>
          <div className='top_header_title align-items-center'>
            <h5 className="font-weight-bold">Manage <strong>{pageData?.sportInfo?.name} [{pageData?.sportInfo?.openDate}]</strong> Premium Bets <strong>Declare</strong></h5>
          </div>
        </div>

        <div className='edit_body'>
          <table className="table01 margin-table">
            <thead>
              <tr className="light-grey-bg">
                <th>No.</th>
                <th>Market</th>
                {type !== 'manage' ? <th>Declared winners</th> : <></>}
                <th>Action</th>
              </tr>
            </thead>
            <tbody id="matches-table">
              {type === 'manage' ?
                pageData?.betList && pageData?.betList.length > 0 ? pageData.betList.map((item: manageBetList, i: any) => {
                  const rowKey = `${item.name}::${item.lineKey || i}`
                  return (
                    <tr key={rowKey}>
                      <td style={{ width: "5%" }}>
                        {i + 1}
                      </td>
                      <td>
                        <span className="text-primary">{item.name}</span>
                        {item.lineLabel ? (
                          <div style={{ fontSize: 12, color: '#475467', marginTop: 2 }}>{item.lineLabel}</div>
                        ) : null}
                      </td>

                      <td style={{ width: "20%" }}>

                        {type === 'manage' ? <>

                          <button onMouseEnter={() => handleMouseEnter(rowKey)} onMouseLeave={() => handleMouseLeave(rowKey)} style={styleObjectBlackButton(DD?.colorSchema, hoverId.isHover === rowKey)} type="button" className="btn btn-warning btn-sm shadow-none btn_black match_view" onClick={() => declareResultClick(item)}>Declare Result</button>
                        </> : <></>}
                      </td>
                    </tr>

                  )
                }) : <h2>No Data</h2>
                :
                pageData?.history && pageData?.history.length > 0 ? pageData.history.map((item: managehistoryPre, i: any) => {
                  const rowKey = `${item.selection || item.name}::${item.lineKey || i}`
                  return (
                    <tr key={rowKey}>
                      <td style={{ width: "5%" }}>
                        {i + 1}
                      </td>
                      <td>
                        <span className="text-primary">{item.selection || item.name}</span>
                        {item.lineLabel ? (
                          <div style={{ fontSize: 12, color: '#475467', marginTop: 2 }}>{item.lineLabel}</div>
                        ) : null}
                      </td>
                      <td>{formatDeclaredWinners(item?.winner)}</td>
                      <td style={{ width: "20%" }}>

                        {type === 'rollback' ? <>
                          <button onMouseEnter={() => handleMouseEnter(rowKey)} onMouseLeave={() => handleMouseLeave(rowKey)} style={styleObjectBlackButton(DD?.colorSchema, hoverId.isHover === rowKey)} type="button" className="btn btn-warning btn-sm shadow-none btn_black match_view" onClick={() => showAlert(item)}>Rollback Result</button>
                        </> : <></>}
                      </td>
                    </tr>

                  )
                }) : <h2>No Data</h2>
              }
            </tbody>
          </table>
        </div >
      </div>

      <UpdateModal
        title={clickedWinner?.name ? `Who won: ${clickedWinner.name}${clickedWinner.lineLabel ? ` — ${clickedWinner.lineLabel}` : ''}` : 'Who won this premium market?'}
        OpenModal={OpenModal}
        closeModel={() => { setOpenModal(false); resetDeclareForm() }}
        type='status'
        btnName={submitButtonLabel(settleMode)}
        customClass="premium-declare-popup"
        clickedWinner={clickedWinner}
        onOutcomeToggle={onOutcomeToggle}
        declaredWinner={declaredWinner}
        settleMode={settleMode}
        onSettleModeChange={onSettleModeChange}
        formError={formError}
        submitForm={submitWinnerPopup}
      />

    </>

  )
}

export default MangePremium




export const UpdateModal = (props: any) => {
  const {
    title,
    OpenModal,
    closeModel,
    submitForm,
    btnName,
    customClass,
    clickedWinner,
    declaredWinner,
    settleMode,
    onSettleModeChange,
    onOutcomeToggle,
    formError,
  } = props

  const [showAdvanced, setShowAdvanced] = useState(false)

  useEffect(() => {
    if (OpenModal) setShowAdvanced(false)
  }, [OpenModal, clickedWinner?.name])

  const runners: string[] = useMemo(
    () => flattenRunners(clickedWinner?.winnerSelection),
    [clickedWinner]
  )
  const preview = useMemo(
    () => settlementPreview(settleMode, declaredWinner || [], runners),
    [settleMode, declaredWinner, runners]
  )
  const inputType = settleMode === 'single' ? 'radio' : 'checkbox'
  const selectedCount = (declaredWinner || []).filter((n: string) => n && n !== 'cancel').length

  const toneStyle = (tone: string): React.CSSProperties => {
    if (tone === 'win') return { color: '#0a7a32', fontWeight: 700 }
    if (tone === 'lose') return { color: '#b42318', fontWeight: 600 }
    if (tone === 'split') return { color: '#b54708', fontWeight: 700 }
    return { color: '#344054', fontWeight: 600 }
  }

  return (
    <>
      <SkyPopup
        title={title}
        OpenModal={OpenModal}
        closeModel={closeModel}
        closebtn={true}
        btnName={btnName}
        customClass={customClass || 'premium-declare-popup'}
        submit={submitForm} >
        <div className='view_winner'>
          <div className="modal-body pl_15 pr_15 pb_0 pt_0" >

            <div
              className="mb_15"
              style={{
                background: '#eff8ff',
                border: '1px solid #b2ddff',
                borderRadius: 4,
                padding: '10px 12px',
                fontSize: 13,
                lineHeight: 1.45,
              }}
            >
              <div style={{ fontWeight: 700, marginBottom: 4 }}>How to declare (simple)</div>
              <div>1. Leave <strong>One winner</strong> selected (default).</div>
              <div>2. Click the outcome that won.</div>
              <div>3. Check the green/red summary below, then press <strong>Publish winner</strong>.</div>
              <div style={{ marginTop: 6, opacity: 0.9 }}>
                Only change the type if it was a <strong>tie</strong> or you need to <strong>void</strong> the market.
              </div>
            </div>

            <div className="mb_10" style={{ fontWeight: 700, fontSize: 13 }}>
              Step 1 — What kind of result?
            </div>
            <div className="mb_15">
              {(
                [
                  {
                    id: 'single' as SettleMode,
                    label: 'One winner',
                    hint: 'Normal — pick exactly one',
                  },
                  {
                    id: 'deadHeat' as SettleMode,
                    label: 'Tie / dead heat',
                    hint: 'Two or more tied — profit shared',
                  },
                  {
                    id: 'cancel' as SettleMode,
                    label: 'Void / cancel',
                    hint: 'No result — return all stakes',
                  },
                ]
              ).map((opt) => (
                <div
                  key={opt.id}
                  className="form-check d_flex d_flex_align_center mb_10"
                  style={{
                    border: settleMode === opt.id ? '2px solid #1570ef' : '1px solid #d0d5dd',
                    borderRadius: 4,
                    padding: '8px 10px',
                    background: settleMode === opt.id ? '#f5faff' : '#fff',
                    marginLeft: 0,
                  }}
                >
                  <input
                    className="form-check-input mr_10"
                    type="radio"
                    id={`settleMode_${opt.id}`}
                    name="premium_settle_mode"
                    checked={settleMode === opt.id}
                    onChange={() => {
                      if (opt.id !== 'allNamed') setShowAdvanced(false)
                      onSettleModeChange(opt.id)
                    }}
                  />
                  <label htmlFor={`settleMode_${opt.id}`} className="form-check-label" style={{ cursor: 'pointer' }}>
                    <span style={{ fontWeight: 700, display: 'block' }}>{opt.label}</span>
                    <span style={{ fontSize: 12, opacity: 0.8 }}>{opt.hint}</span>
                  </label>
                </div>
              ))}

              <button
                type="button"
                className="btn btn-link btn-sm p-0"
                style={{ fontSize: 12 }}
                onClick={() => setShowAdvanced((v) => !v)}
              >
                {showAdvanced ? 'Hide rare option' : 'Show rare option (advanced)'}
              </button>

              {showAdvanced ? (
                <div
                  className="form-check d_flex d_flex_align_center mt_10 mb_10"
                  style={{
                    border: settleMode === 'allNamed' ? '2px solid #b42318' : '1px solid #fecdca',
                    borderRadius: 4,
                    padding: '8px 10px',
                    background: settleMode === 'allNamed' ? '#fef3f2' : '#fff',
                    marginLeft: 0,
                  }}
                >
                  <input
                    className="form-check-input mr_10"
                    type="radio"
                    id="settleMode_allNamed"
                    name="premium_settle_mode"
                    checked={settleMode === 'allNamed'}
                    onChange={() => onSettleModeChange('allNamed')}
                  />
                  <label htmlFor="settleMode_allNamed" className="form-check-label" style={{ cursor: 'pointer' }}>
                    <span style={{ fontWeight: 700, display: 'block', color: '#b42318' }}>
                      Advanced: pay every selected outcome full win
                    </span>
                    <span style={{ fontSize: 12, opacity: 0.85 }}>
                      Do not use for a normal match result. Overpays if used by mistake.
                    </span>
                  </label>
                </div>
              ) : null}
            </div>

            <div
              className="mb_15"
              style={{ fontSize: 12, lineHeight: 1.4, color: '#475467' }}
            >
              {modeHelp(settleMode)}
            </div>

            {settleMode !== 'cancel' ? (
              <>
                <div className="mb_10" style={{ fontWeight: 700, fontSize: 13 }}>
                  Step 2 — {settleMode === 'single' ? 'Select the winner' : 'Select the winning outcomes'}
                  {selectedCount > 0 ? (
                    <span style={{ fontWeight: 500, marginLeft: 8, opacity: 0.75 }}>
                      ({selectedCount} selected)
                    </span>
                  ) : null}
                </div>
                {runners.length === 0 ? (
                  <p style={{ fontSize: 13, color: '#b42318' }}>
                    No outcomes found for this market. Refresh the page and try again.
                  </p>
                ) : (
                  runners.map((item: string) => {
                    const checked = (declaredWinner || []).includes(item)
                    return (
                      <div
                        key={item}
                        className="form-check d_flex d_flex_align_center mb_10"
                        style={{
                          border: checked ? '2px solid #099250' : '1px solid #d0d5dd',
                          borderRadius: 4,
                          padding: '8px 10px',
                          background: checked ? '#edfcf2' : '#fff',
                          marginLeft: 0,
                        }}
                      >
                        <input
                          className="form-check-input mr_10"
                          onChange={() => onOutcomeToggle(item)}
                          type={inputType}
                          id={`outcome_${item}`}
                          name={settleMode === 'single' ? 'premium_single_winner' : `premium_multi_${item}`}
                          checked={checked}
                        />
                        <label htmlFor={`outcome_${item}`} className="form-check-label" style={{ cursor: 'pointer', fontWeight: 600, flex: 1 }}>
                          {item}
                          {checked ? (
                            <span style={{ marginLeft: 8, fontSize: 12, color: '#099250', fontWeight: 700 }}>
                              SELECTED
                            </span>
                          ) : null}
                        </label>
                      </div>
                    )
                  })
                )}
              </>
            ) : (
              <div
                className="mb_15"
                style={{
                  background: '#fffaeb',
                  border: '1px solid #fedf89',
                  borderRadius: 4,
                  padding: '10px 12px',
                  fontSize: 13,
                }}
              >
                All open bets on <strong>{clickedWinner?.name || 'this market'}</strong> will be
                voided. Players get stake back. No winner / loser.
              </div>
            )}

            {preview.length > 0 ? (
              <div
                className="mt_10 mb_10"
                style={{
                  fontSize: 13,
                  background: '#f9fafb',
                  border: '1px solid #eaecf0',
                  borderRadius: 4,
                  padding: 12,
                }}
              >
                <div style={{ fontWeight: 700, marginBottom: 8 }}>
                  Step 3 — Check before publish
                </div>
                {preview.map((row) => (
                  <div
                    key={row.name}
                    className="d_flex d_flex_justify_spacebt d_flex_align_center"
                    style={{ padding: '4px 0', borderBottom: '1px solid #f2f4f7' }}
                  >
                    <span>{row.name}</span>
                    <span style={toneStyle(row.tone)}>{row.result}</span>
                  </div>
                ))}
              </div>
            ) : null}

            {formError ? (
              <span
                className="error"
                style={{
                  color: 'red',
                  display: 'block',
                  fontSize: 12,
                  marginBottom: 10,
                }}
              >
                {formError}
              </span>
            ) : null}

          </div>
        </div>
      </SkyPopup>
    </>
  )
}
